import React from "react";
import "./SpeedBadge.scss";

export default function SpeedBadge({ children, className = "" , ...rest }) {
    return (
        <div className={`speed-badge ${className}`} {...rest}>
            {/* create 4 chevrons */}
            {Array.from({ length: 4 }, (_, index) => (
                <svg className="chevron" key={index} width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.9922 29.0492L22.5005 19.5409C23.6234 18.418 23.6234 16.5805 22.5005 15.4576L12.9922 5.94922" stroke="white" strokeWidth="3" strokeMiterlimit="10" strokeLinejoin="round"/>
                </svg>
            ))}
        </div>
    );
}
